export default __webpack_public_path__ + "static/media/Dotspartial Vectors-03.9b1b13ba.png";